define('../app/fukit/view/block/fullscreen.saveable.sidebar.view',['require','exports','module','underscore','marionette','uikit/uikit','../../blockit.shared','../../helpers/factory','../../helpers/extend.util','../../behavior/modal.save.button.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Mn                      = require('marionette'),
      UIKit                   = require('uikit/uikit'),
      BlocKit                 = require('../../blockit.shared'),
      Factory                 = require('../../helpers/factory'),
      ExtendUtil              = require('../../helpers/extend.util'),
      ModalSaveButtonBehavior = require('../../behavior/modal.save.button.behavior');

  var FullscreenSaveableSidebarView = UIKit.Sidebar2.extend({
    options: _.extend({}, UIKit.Sidebar2.prototype.options, {
      width: 'fullscreen',
    }),

    internalViewOptions: UIKit.Sidebar2.extendInternalViewOptions({
      headerView: ExtendUtil.extendOptionValueWithDefaults('header', function() {
        return {
          actions: _.extend(
            {
              components: [
                {
                  type: UIKit.Sidebar2.DenyButtonView,
                  text: 'Cancel',
                },
                Factory.saveButton({
                  type: UIKit.Sidebar2.ConfirmButtonView,
                  name: 'saveButton',
                  model: this.model,
                  behaviors: {
                    ModalSaveButtonBehavior: {
                      behaviorClass: ModalSaveButtonBehavior,
                    },
                  },
                }),
              ],
            },
            Mn._getValue(this.getOption('actions'), this)
          ),
        };
      }),

      actionsView: function() {
        // we don't want anything in the actions view
        return { components: [], collection: null };
      },
      contentView: function() {
        //prettier-ignore
        var content    = Mn._getValue(this.getOption('content'), this),
            components = content && content.components ? content.components : [];
        var messagesComponent = {
          type: UIKit.Message,
          name: 'messagesComponent',
          behaviors: {
            ResourceErrorsBehavior: _.extend({}, this.getOption('resourceErrorsOptions'), {
              ignoreAllControllerResources: true,
              behaviorClass: BlocKit.ResourceErrorsBehavior,
            }),
          },
        };

        return _.extend({}, content, {
          components: _.union([messagesComponent], components),
        });
      },
    }),
  });

  module.exports = FullscreenSaveableSidebarView;
});

